import { render, staticRenderFns } from "./IFramePage.vue?vue&type=template&id=6a792c92"
import script from "./IFramePage.vue?vue&type=script&lang=js"
export * from "./IFramePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports